<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_16763_30962"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="21"
    >
      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16763_30962)">
      <rect
        x="4.1665"
        y="3.83331"
        width="11.6667"
        height="14.1667"
        rx="2"
        stroke="#666666"
        stroke-width="1.5"
        class="stroke"
      />
      <path
        d="M7.5 8H12.5"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
      <path
        d="M7.5 11.3333H12.5"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
      <path
        d="M7.5 14.6667H10.8333"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.v-list-item--active svg .fill {
  fill: #df252a;
}
.v-list-item--active svg .stroke {
  stroke: #df252a;
}
</style>
